"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated `@faire/slate/icons/Divider` instead */
export const Divider = createSVGIcon(
  <path
    d="M17.923 7H6.077C5.482 7 5 7.344 5 7.77v8.46c0 .426.482.77 1.077.77h11.846c.595 0 1.077-.344 1.077-.77V7.77c0-.426-.482-.77-1.077-.77ZM2 12h20"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "Divider",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      defaultMessage: "Add divider",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
    color: Core.icon.default,
  })
);
